/**
 * Local design tokens for GKVNew module.
 *
 * These override MUI's generous defaults to achieve a compact, data-dense layout.
 * Do NOT import the global theme here — reference token values directly so they can
 * be used in styled() calls without requiring ThemeProvider context.
 */

// ── Spacing ──
export const spacing = {
  xs: "2px",
  sm: "4px",
  md: "8px",
  lg: "12px",
  xl: "16px",
} as const;

// ── Typography ──
export const fontSize = {
  label: "0.7rem",
  data: "0.875rem",
  dataLg: "0.95rem",
  heading: "1rem",
  headingLg: "1.1rem",
  tag: "0.7rem",
} as const;

// ── Border Radius ──
export const radius = {
  xs: "3px",
  sm: "4px",
  md: "8px",
  lg: "12px",
  xl: "16px",
} as const;

// ── Colors (aliased from mobiliTheme values) ──
export const colors = {
  // Surfaces
  headerBg: "#5c758a",
  cardBg: "#D9DFE2",
  tableBg: "#bdbdbd",
  rowHover: "#eef2f5",
  rowSelected: "#d4e3f5",
  infoBg: "#ffffff",
  payerName: "#e8eef1",

  // Borders
  borderLight: "#e0e0e0",
  borderMedium: "#969696",
  borderDark: "#003059",

  // Text
  textPrimary: "#1a1a1a",
  textSecondary: "#555555",
  textMuted: "#888888",
  textOnDark: "#ffffff",

  // Semantic
  valid: "#6FBF99",
  invalid: "#FF0000",
  info: "#4361FF",
  warning: "#FFE80B",
  accent: "#9C1A35",
  lightWarning: "#edb54e",

  // Tags
  therapyTag: "#655ebb",
  therapyTagGradientEnd: "#788ce6",

  //extra
  darkBlue: "#617282"
} as const;

// ── Shadows ──
export const shadow = {
  none: "none",
  sm: "0 1px 3px rgba(0,0,0,0.08)",
  md: "0 2px 6px rgba(0,0,0,0.1)",
  lg: "0 4px 12px rgba(0,0,0,0.12)",
} as const;

// ── Table-specific ──
export const table = {
  cellPadding: "4px 8px",
  headerPadding: "6px 8px",
  headerFontSize: fontSize.dataLg,
  cellFontSize: fontSize.data,
  rowMinHeight: "36px",
  checkboxWidth: "32px",
} as const;

// ── Card-specific ──
export const card = {
  headerPadding: `${spacing.sm} ${spacing.lg}`,
  bodyPadding: spacing.lg,
  metaGap: spacing.lg,
  metaDivider: `1px solid ${colors.borderLight}`,
} as const;

// ── Summary bar ──
export const summary = {
  itemGap: spacing.md,
  itemPadding: `${spacing.sm} ${spacing.md}`,
  dotSize: "8px",
} as const;
